import type { RouteObject } from 'react-router-dom';
import { RequirePermission } from '../auth/guards';
import { CouponsPage } from './CouponsPage';
import { ReportPage } from '../reports/ReportPage';
import { DigitalCardsPage } from './DigitalCardsPage';

/** Coupon codes (PC852) and Digital Card (PC1141), both top-level sidebar entries. */
export const promotionsRoutes: RouteObject[] = [
  {
    path: 'coupons',
    element: (
      <RequirePermission code="PC852">
        <CouponsPage />
      </RequirePermission>
    ),
  },
  // "View Report": ReportPage applies its code (PC852) and its switch.
  { path: 'coupons/report', element: <ReportPage reportKey="coupon-usage" /> },
  {
    path: 'digital-cards',
    element: (
      <RequirePermission code="PC1141">
        <DigitalCardsPage />
      </RequirePermission>
    ),
  },
];
